window.StickyATCAB = window.StickyATCAB || {};

(function(atc) {
  atc.variant = atc.variant || null;
  atc.initialized = false;
  atc._enableRequested = atc._enableRequested || false;

  atc.setVariant = (v) => {
    atc.variant = v;
    if (v === 'show') atc.enable();
  };

  atc.enable = () => {
    if (atc.active) return;
    atc._enableRequested = true;
    atc.active = true;
    
    document.documentElement.classList.add('sticky-atc-enabled');
    atc._initElements();
    window.dispatchEvent(new CustomEvent('sticky-atc:enable'));
  };

  atc._initElements = () => {
    if (atc.initialized) return;

    const items = document.querySelectorAll('sticky-atc');
    if (items.length) {
      items.forEach(el => {
        el.style.display = 'flex';
        el.classList.add('ab-enabled');
      });
      atc.initialized = true;
    } else {
      setTimeout(() => atc._initElements(), 50);
    }
  };

  atc.isShowVariant = () => atc.variant === 'show';
  atc.isEnabled = () => atc._enableRequested || atc.variant === 'show';

  if (atc._enableRequested) atc.enable();
})(window.StickyATCAB);
